export default __webpack_public_path__ + "static/media/TF.21112fdf.webp";